"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PricingZoneWithCustomerDiscounts = void 0;
const typebox_1 = require("@sinclair/typebox");
const customer_discount_transport_1 = require("./customer-discount-transport");
const pricing_zone_1 = require("./pricing-zone");
exports.PricingZoneWithCustomerDiscounts = typebox_1.Type.Intersect([
    pricing_zone_1.PricingZone,
    typebox_1.Type.Object({
        customerDiscounts: typebox_1.Type.Optional(typebox_1.Type.Array(customer_discount_transport_1.EmbeddedCustomerDiscountTransport)),
    }),
]);
//# sourceMappingURL=pricing-zone-with-customer-discounts.js.map